<template>
    <div class="data_body">
        <div style="width: 100%; height: 100%;display: flex;align-items: center;justify-content: center;">
            <!-- <div id="cateRank" class="echart" style="width: 100%; height: 100%"></div> -->
            <highcharts :options="option" style="width: 95%; height: 95%"></highcharts>
        </div>
    </div>
</template>
  
<script>
import { Chart } from 'highcharts-vue'
import HighCharts from 'highcharts'
//和弦图的引入依赖
// import column from 'highcharts/modules/column';
// column(HighCharts);

export default {
    components: {
        highcharts: Chart,
    },
    props: {
        weekCourse2: {
            type: Array,
        },
    },
    data() {
        return {
            chartObj: null,
            ooption: {
                data: [],
            },
            option: {
                chart: {
                    type: 'column',
                    inverted: true
                },
                credits: {
                    enabled: false//不显示LOGO
                },
                title: {
                    text: null,
                },
                xAxis: {
                    categories: ['按协同比例']
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: null
                    }
                },
                tooltip: {
                    pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b>' +
                        '({point.percentage:.0f}%)<br/>',
                    //:.0f 表示保留 0 位小数，详见教程：https://www.hcharts.cn/docs/basic-labels-string-formatting
                    shared: true
                },
                plotOptions: {
                    column: {
                        stacking: 'percent'
                    }
                },
                legend: {
                    align: 'center',
                    verticalAlign: 'top',
                    floating: true,
                    backgroundColor: 'white',
                    borderColor: '#CCC',
                    borderWidth: 1,
                    shadow: false
                },
                series: [{
                    name: '教师协作',
                    data: [5]
                }, {
                    name: '师生协作',
                    data: [2]
                }, {
                    name: '生生协作',
                    data: [3]
                }]
            }
        };
    },
    methods: {
        setChart() {
            // 雷达图显示的标签
            let newPromise = new Promise((resolve) => {
                resolve();
            });
            //然后异步执行echarts的初始化函数
            newPromise.then(() => {
                const chartObj = Highcharts.chart('cateRank', this.option);
                // 初始化雷达图
                // this.chartObj = chartObj;
                // this.chartObj.setOption(this.option);
            });
        },
        setArray(array) {
            this.option.xAxis.categories = []
            this.option.series[0].data = []
            this.option.series[1].data = []
            for (var i = 0; i < array.length; i++) {
                this.option.xAxis.categories.push(array[i].name)
                this.option.series[0].data.push(array[i].lastWeekCouseCount)
                this.option.series[1].data.push(array[i].toWeekCouseCount)
            }
        }
    },
    watch: {
        weekCourse2: {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {
                // this.setArray(newValue)
                this.$forceUpdate();
            },
        },
    },
    mounted() {
        // this.setArray(this.weekCourse2)
        // this.setChart();

    },
};
</script>
  
<style scoped>
.data_body {
    height: 100%;
    /* display: flex; */
    position: relative;
    border-radius: 5px;
    /* border: 1px solid #eee; */
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0;
    width: 95%;
    /* background: #fff; */
}
</style>


// WEBPACK FOOTER //
// src/components/pages/dataBoardNew/project/chartList/bar/cCourse.vue